import { Trans, useTranslation } from 'react-i18next'
import { StyleProp, StyleSheet, ViewStyle } from 'react-native'
import { Font, FormField, MultipleSelect, MultipleSelectProps, Text, Weekday, titleForWeekday } from 'zens-storybook'

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  label: {
    fontFamily: Font.light,
  },
})

interface Props extends MultipleSelectProps<Weekday> {
  helpStyle?: StyleProp<ViewStyle>
}

const InsightsWeekdays = (props: Props) => {
  const { helpStyle, style, ...otherProps } = props
  const { t } = useTranslation()

  const items = [
    {
      title: t('Work days'),
      items: ['mon', 'tue', 'wed', 'thu', 'fri'].map((weekday) => ({
        title: titleForWeekday(weekday as Weekday, t),
        value: weekday,
      })),
    },
    {
      title: t('Weekend days'),
      items: ['sat', 'sun'].map((weekday) => ({
        title: titleForWeekday(weekday as Weekday, t),
        value: weekday,
      })),
    },
  ]

  return (
    <FormField
      label={t('Weekdays')}
      style={[styles.container, style]}
      labelStyle={styles.label}
      help={
        <Text style={helpStyle}>
          <Trans>Only activity at selected weekdays will be taken into account.</Trans>
        </Text>
      }
    >
      <MultipleSelect items={items} placeholder={t('All days')} testID="InsightsWeekdays.Select" {...otherProps} />
    </FormField>
  )
}

export default InsightsWeekdays
